import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'oval-icon, [ovalIcon]',
  template: '<i class="icon" [ngClass]="iconClass"><ng-content></ng-content></i>',
  styleUrls: ['oval-icon.component.scss'],
})
export class OvalIconComponent {

  @Input() iconClass: string = '';

}
